/* eslint-disable promise/param-names */
import {
  IMPRESSUM_SUCCESS,
  IMPRESSUM_DEFAULT,
  IMPRESSUM_SAVE,
  IMPRESSUM_LOAD,
} from '@/store/actions/impressum';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

import querystring from 'querystring-browser';
import moment from 'moment';

import Vue from 'vue';
import {sleep} from '@/utils/utils.js'

const storageBaseLink = process.env.VUE_APP_STORAGE_BASE_LINK

const state = { 
  impressum: '',
  status: '',
  hasLoadedOnce: false,
};

const getters = {
  impressum: state => state.impressum ? state.impressum : '',
  impressumLoading: state => state.status == 'loading',
  impressumLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [IMPRESSUM_LOAD]: ({commit}) => {
    return new Promise((resolve) => {
      commit(IMPRESSUM_LOAD)

      firebase.firestore().collection('pages').doc('impressum').get()
          .then(documentSnapshot => {
            if (documentSnapshot.exists) {
              commit(IMPRESSUM_SUCCESS, documentSnapshot.data().text);
            }

            commit(IMPRESSUM_SUCCESS);
            resolve('');
          })
    })
  },

  [IMPRESSUM_SAVE]: ({commit}, impressum) => {
    commit(IMPRESSUM_LOAD)
    firebase.firestore().collection('pages').doc('impressum').update({
      text: impressum
    })
        .then(() => {
          commit(IMPRESSUM_SUCCESS);
        })
  },

  [IMPRESSUM_DEFAULT]: ({commit}, impressum) => {
    commit(IMPRESSUM_LOAD)

    firebase.firestore().collection('pages').doc('impressum').get()
        .then(documentSnapshot => {
          if (documentSnapshot.exists && documentSnapshot.data().default) {
            let defaultText = documentSnapshot.data().default;

            return firebase.firestore().collection('pages').doc('impressum').update({
              text: defaultText
            })
            .then(() => {
              return commit(IMPRESSUM_SUCCESS, defaultText);
            })
          }

          commit(IMPRESSUM_SUCCESS);
        });
  },
}

const mutations = {
  [IMPRESSUM_LOAD]: (state) => {
    state.status = 'loading';
  },

  [IMPRESSUM_SUCCESS]: (state, impressum) => {
    state.status = 'success'

    if (impressum !== undefined) {
      state.impressum = impressum;
      state.hasLoadedOnce = true;
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
